import { render, staticRenderFns } from "./DropdownSelect.global.vue?vue&type=template&id=4715e50a&scoped=true&lang=pug&"
import script from "./DropdownSelect.global.vue?vue&type=script&lang=ts&"
export * from "./DropdownSelect.global.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownSelect.global.vue?vue&type=style&index=0&id=4715e50a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4715e50a",
  null
  
)

export default component.exports